import { Component, Input } from '@angular/core';
import { ColumnSettings } from '../../common/models';

@Component({
    selector: 'date-editor',
    templateUrl: './date-editor.component.html',
    styleUrls: ['./date-editor.component.scss'],
})
export class DateEditorComponent {
  @Input('record') record: any;
  @Input('column') column!: ColumnSettings;
}
